"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOL_ROUTES = exports.SEO_ROBOTS = exports.JSON_LD_TYPES = void 0;
/** JSON-LD types a tool route may declare. Organization is included only when WordPress does not already emit it. */
exports.JSON_LD_TYPES = ["WebApplication", "BreadcrumbList", "FAQPage", "Organization"];
exports.SEO_ROBOTS = ["index,follow", "noindex,follow"];
const ORIGIN = "https://handshake.finance";
const startJsonLd = ["WebApplication", "BreadcrumbList", "FAQPage"];
exports.TOOL_ROUTES = [
    {
        path: "/renovation-payment-schedule-checker/",
        stability: "fixed",
        release: "r1",
        indexable: true,
        prerender: true,
        robots: "index,follow",
        canonicalUrl: `${ORIGIN}/renovation-payment-schedule-checker/`,
        title: "Renovation Payment Schedule Checker (Free) | Handshake",
        jsonLdTypes: startJsonLd,
    },
    {
        path: "/renovation-payment-schedule-checker/schedule/",
        stability: "provisional",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/renovation-payment-schedule-checker/`,
        jsonLdTypes: [],
    },
    {
        path: "/renovation-payment-schedule-checker/report/",
        stability: "provisional",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/renovation-payment-schedule-checker/`,
        jsonLdTypes: [],
    },
    {
        path: "/interior-designer-scorecard/",
        stability: "fixed",
        release: "r1",
        indexable: true,
        prerender: true,
        robots: "index,follow",
        canonicalUrl: `${ORIGIN}/interior-designer-scorecard/`,
        title: "How to Choose an Interior Designer: Free ID Scorecard | Handshake",
        jsonLdTypes: startJsonLd,
    },
    {
        path: "/interior-designer-scorecard/how-its-scored/",
        stability: "fixed",
        release: "r1",
        indexable: false,
        prerender: true,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/interior-designer-scorecard/`,
        jsonLdTypes: ["BreadcrumbList"],
    },
    {
        path: "/interior-designer-scorecard/ids/",
        stability: "provisional",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/interior-designer-scorecard/`,
        jsonLdTypes: [],
    },
    {
        path: "/interior-designer-scorecard/report/",
        stability: "provisional",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/interior-designer-scorecard/`,
        jsonLdTypes: [],
    },
    {
        path: "/interior-designer-scorecard/compare/",
        stability: "provisional",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/interior-designer-scorecard/`,
        jsonLdTypes: [],
    },
    {
        path: "/handshake-renovation-escrow/",
        stability: "fixed",
        release: "r1",
        indexable: true,
        prerender: true,
        robots: "index,follow",
        canonicalUrl: `${ORIGIN}/handshake-renovation-escrow/`,
        title: "How Renovation Escrow Works in Singapore | Handshake",
        jsonLdTypes: startJsonLd,
    },
    {
        path: "/invite-interior-designer/",
        stability: "fixed",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "noindex,follow",
        canonicalUrl: `${ORIGIN}/invite-interior-designer/`,
        jsonLdTypes: [],
    },
    {
        path: "/interior-designer-due-diligence/",
        stability: "provisional",
        release: "r2",
        indexable: true,
        prerender: true,
        robots: "index,follow",
        canonicalUrl: `${ORIGIN}/interior-designer-due-diligence/`,
        jsonLdTypes: startJsonLd,
    },
    {
        path: "/tools/r/:code",
        stability: "fixed",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "disallow",
        jsonLdTypes: [],
    },
    {
        path: "/tools/api/*",
        stability: "fixed",
        release: "r1",
        indexable: false,
        prerender: false,
        robots: "disallow",
        jsonLdTypes: [],
    },
];
